module.exports = __webpack_public_path__ + "components/country-flag/static/pl-c9b2eeadb6765f59acb5d83c23f91ddd.svg";